module.exports={Earlier:"較早",New:"新增",newNotification:"{newCount} 則新通知",newNotifications:"{newCount} 則新通知",noNotifications:"您沒有任何通知"};